import { createSlice } from '@reduxjs/toolkit';
import { authActions } from './auth.actions';
import jwt_decode from "jwt-decode";

// User Token
var authToken = localStorage.getItem("token") || null;
let primaryUser = localStorage.getItem("isPrimaryUser") === "true" || false;

// ------ Auth Reducer for managing authentication state. ------
const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: !!localStorage.getItem("user"),
    token: null,
    userObject: authToken ? jwt_decode(authToken) : {permissions: [], projectId: ""},
    error: "",
    loading: false,
    loginSuccess: false,
    optSent: null,
    otpVerification: false,
    verifiedOtp: "",
    resetPasswordSuccess: false,
    userRegistered: "",
    accountPreferences: null,
    isPrimaryUser: primaryUser ,
    isReadOnly: localStorage.getItem("isReadOnly") === "true" || false,
    projectList: [],
  },
  reducers: {
    // -------- Logout state ------
    logout: (state, action) => {
      localStorage.clear();
      state.isAuthenticated = false;
      state.token = null;
      state.userObject = {permissions: []};
      state.error = "";
    },
    // -------- Reset all the auth error state for forgotpassword, login and resetpassword. ------
    resetError: (state) => {
      state.loading = false;
      state.error = "";
      state.loginSuccess = false;
      state.optSent = null;
      state.resetPasswordSuccess = false;
      state.userRegistered = "";
    },
    // -------- Handle redirect from back-office ------
    loginFromBackoffice: (state, action) =>{
      state.loading = false;
      state.isAuthenticated = true;
      let userObject:any = jwt_decode(action.payload)
      state.userObject = userObject;
      localStorage.setItem("activeUserId",userObject.id);
      localStorage.setItem("token", action.payload);


      state.isPrimaryUser = userObject.isPrimaryUser
      localStorage.setItem("isPrimaryUser", userObject.isPrimaryUser);
      state.isReadOnly = userObject.isReadOnly || false;
      localStorage.setItem("isReadOnly", userObject.isReadOnly || false);

      state.error = "";
      state.token = action.payload;
      state.loginSuccess = true;
    }
  },
  extraReducers: (builder) => {
    builder
       // -------- cases of Login api data -------
       .addCase(authActions.loginAction.pending, (state, action) => {
        state.userObject = {permissions: []};
        state.error = "";
        state.loading = true;
        state.loginSuccess = false;
        state.isPrimaryUser = false;
        state.isReadOnly = false;
      })
      .addCase(authActions.loginAction.fulfilled, (state, action) => {
        if (action?.payload?.status === 200) {
          if (action.payload.data.data?.token) {
            state.loading = false;
            state.isAuthenticated = true;
            let userObject:any = jwt_decode(action.payload.data.data?.token)
            state.userObject = userObject;
            localStorage.setItem("activeUserId",userObject.id);
            localStorage.setItem("token", action.payload.data.data.token);
            state.error = "";
            state.token = action.payload.data.data.token;
            state.loginSuccess = true;


            state.isPrimaryUser = action.payload.data.data.isPrimaryUser
            localStorage.setItem("isPrimaryUser", action.payload.data.data.isPrimaryUser);
            state.isReadOnly = action.payload.data.data.isReadOnly || false;
            localStorage.setItem("isReadOnly", action.payload.data.data.isReadOnly || false);

          } else {
            state.loading = false;
            state.isAuthenticated = false;
            state.loginSuccess = false;
            
            state.isPrimaryUser = false;
            state.isReadOnly = false;
            localStorage.removeItem("isPrimaryUser");
            localStorage.removeItem("isReadOnly");
            
            localStorage.removeItem("activeUserId")
            localStorage.removeItem("token");
            state.error = "unable to loginAction properly.";
          }
        } else {
          state.loading = false;
          state.isAuthenticated = false;
          state.loginSuccess = false;
          state.isPrimaryUser = false;
          state.isReadOnly = false;
          localStorage.removeItem("isPrimaryUser");
          localStorage.removeItem("isReadOnly");
          localStorage.removeItem("activeUserId")
          localStorage.removeItem("token");
          state.error = "unable to loginAction properly.";
        }
        
      })
      .addCase(authActions.loginAction.rejected, (state, action: any) => {
        state.userObject = {permissions: []};
        state.loading = false;
        state.loginSuccess = false;
        state.isPrimaryUser = false;
        state.isReadOnly = false;
        localStorage.removeItem("isPrimaryUser");
        localStorage.removeItem("isReadOnly");
        if(action.payload.status === 401){
          state.error = action?.payload?.data?.message || "unable to loginAction properly.";
        }else if(action.payload.status === 422){
          state.error = action.payload.data.details[0].message || "unable to loginAction properly.";
        }else {
          state.error = action?.payload?.data?.message || "unable to loginAction properly.";
        }
        
      })

      // -------- cases of getting project list api request -------
      .addCase(authActions.getpProjectListAction.pending, (state, action) => {
        state.error = "";
        state.loading = true;
        state.projectList = [];
      })
      .addCase(authActions.getpProjectListAction.fulfilled, (state, action) => {
        state.error = "";
        state.loading = false;
        state.projectList = action.payload.data?.data;
      })
      .addCase(authActions.getpProjectListAction.rejected, (state, action: any) => {
        state.loading = false;
        state.projectList = [];
        state.error = action.error?.message || "";
      })

      // -------- cases of selecting project api request -------
      .addCase(authActions.selectProjectAction.pending, (state, action) => {
        // state.userObject = {permissions: []};
        state.error = "";
        state.loading = true;
        state.loginSuccess = false;
        state.isPrimaryUser = false;
        state.isReadOnly = false;
        localStorage.removeItem("isPrimaryUser");
        localStorage.removeItem("isReadOnly");
      })
      .addCase(authActions.selectProjectAction.fulfilled, (state, action) => {
        if (action?.payload?.status === 200) {
          if (action.payload.data.data?.token) {
            // state.loading = false;
            state.isAuthenticated = true;
            let userObject:any = jwt_decode(action.payload.data.data?.token)
            state.userObject = userObject;
            localStorage.setItem("activeUserId",userObject.id);
            localStorage.setItem("token", action.payload.data.data.token);
            state.error = "";
            state.token = action.payload.data.data.token;
            state.loginSuccess = true;


            state.isPrimaryUser = action.payload.data.data.isPrimaryUser
            localStorage.setItem("isPrimaryUser", action.payload.data.data.isPrimaryUser);
            state.isReadOnly = action.payload.data.data.isReadOnly || false;
            localStorage.setItem("isReadOnly", action.payload.data.data.isReadOnly || false);
          } else {
            state.loading = false;
            state.isAuthenticated = false;
            state.loginSuccess = false;

            state.isPrimaryUser = false;
            state.isReadOnly = false;
            localStorage.removeItem("isPrimaryUser");
            localStorage.removeItem("isReadOnly");

            localStorage.removeItem("activeUserId")
            localStorage.removeItem("token");
            state.error = "unable to loginAction properly.";
          }
        } else {
          state.loading = false;
          state.isAuthenticated = false;
          state.loginSuccess = false;
          
          state.isPrimaryUser = false;
          state.isReadOnly = false;
          localStorage.removeItem("isPrimaryUser");
          localStorage.removeItem("isReadOnly");

          localStorage.removeItem("activeUserId")
          localStorage.removeItem("token");
          state.error = "unable to loginAction properly.";
        }
      })
      .addCase(authActions.selectProjectAction.rejected, (state, action: any) => {
        state.userObject = {permissions: []};
        state.loading = false;
        state.loginSuccess = false;
        
        state.isPrimaryUser = false;
        state.isReadOnly = false;
        localStorage.removeItem("isPrimaryUser");
        localStorage.removeItem("isReadOnly");

        if(action.payload.status === 401){
          state.error = action?.payload?.data?.message || "unable to loginAction properly.";
        }else if(action.payload.status === 422){
          state.error = action.payload.data.details[0].message || "unable to loginAction properly.";
        }else {
          state.error = action?.payload?.data?.message || "unable to loginAction properly.";
        }
      })

      // -------- cases of setting favorite project api request -------
      .addCase(authActions.setFavoriteProjectAction.pending, (state, action) => {
        state.error = "";
        // state.loading = true;
        // state.projectList = [];
      })
      .addCase(authActions.setFavoriteProjectAction.fulfilled, (state, action) => {
        state.error = "";
        // state.loading = false;
        state.projectList = action.payload.data?.data;
      })
      .addCase(authActions.setFavoriteProjectAction.rejected, (state, action: any) => {
        // state.loading = false;
        state.projectList = [];
        state.error = action.error?.message || "";
      })

      // -------- cases of sending OTP api request -------
      .addCase(authActions.sendOtpAction.pending, (state, action) => {
        state.optSent = null
        state.error = "";
        state.loading = true;
      })
      .addCase(authActions.sendOtpAction.fulfilled, (state, action) => {
        state.optSent = action.payload.data?.message
        state.error = "";
        state.loading = false;
      })
      .addCase(authActions.sendOtpAction.rejected, (state, action: any) => {
        state.optSent = null
        state.loading = false;
        if(action.payload.status === 401){
          state.error = action?.payload?.data?.message || "";
        }else if(action.payload.status === 400){
          state.error = action.payload.data.message || "";
        }else if(action.payload.status === 422){
          state.error = action.payload.data.details[0].message || "";
        }else {
          state.error = action.error?.message || "";
        }
      })
      // -------- cases of verifying OTP api request -------
      .addCase(authActions.verifyOtpAction.pending, (state, action) => {
        state.otpVerification = false
        state.verifiedOtp = action?.meta?.arg?.code
        state.error = "";
        state.loading = true;
      })
      .addCase(authActions.verifyOtpAction.fulfilled, (state, action) => {
        state.otpVerification = action.payload.data?.success
        state.error = "";
        state.loading = false;
      })
      .addCase(authActions.verifyOtpAction.rejected, (state, action: any) => {
        state.otpVerification = false
        state.loading = false;
        if(action.payload.status === 401){
          state.error = action?.payload?.data?.message || "";
        }else if(action.payload.status === 400){
          state.error = action.payload.data.message || "";
        }else if(action.payload.status === 422){
          state.error = action.payload.data.details[0].message || "";
        }else {
          state.error = action.error?.message || "";
        }
      })
      // -------- cases of reset password api request -------
      .addCase(authActions.resetPasswordAction.pending, (state, action) => {
        state.resetPasswordSuccess = false;
        state.error = "";
        state.loading = true;
      })
      .addCase(authActions.resetPasswordAction.fulfilled, (state, action) => {
        state.resetPasswordSuccess = action.payload.data?.message;
        state.error = "";
        state.loading = false;
      })
      .addCase(authActions.resetPasswordAction.rejected, (state, action: any) => {
        state.resetPasswordSuccess = false;
        state.loading = false;
        if(action.payload.status === 401){
          state.error = action?.payload?.data?.message || "";
        }else if(action.payload.status === 400){
          state.error = action.payload.data.message || "";
        }else if(action.payload.status === 422){
          state.error = action.payload.data.details[0].message || "";
        }else {
          state.error = action.error?.message || "";
        }
      })
      // -------- cases of Register User api request -------
      .addCase(authActions.registerUserAction.pending, (state, action) => {
        state.userRegistered = "";
        state.error = "";
        state.loading = true;
      })
      .addCase(authActions.registerUserAction.fulfilled, (state, action) => {
        if (action?.payload?.data?.status === 200) {
          state.userRegistered = action.payload.data?.message;
          state.error = "";
          state.loading = false;
        } else {
          state.userRegistered = "";
          state.error = "Register failed";
          state.loading = false;
        }
        
      })
      .addCase(authActions.registerUserAction.rejected, (state, action: any) => {
        state.userRegistered = "";
        state.loading = false;
        if(action.payload.status === 401){
          state.error = action?.payload?.data?.message || "Register failed";
        }else if(action.payload.status === 400){
          state.error = action.payload.data.message || "Register failed";
        }else if(action.payload.status === 422){
          state.error = action.payload.data.details[0].message || "Register failed";
        }else {
          state.error = action?.payload?.data?.message || "Register failed";
        }
      })
      
      // -------- cases of reset password api request -------
      .addCase(authActions.getUserPreferencesAction.pending, (state, action) => {
        state.error = "";
        state.loading = true;
        state.accountPreferences = null;
      })
      .addCase(authActions.getUserPreferencesAction.fulfilled, (state, action) => {
        state.error = "";
        state.loading = false;
        state.accountPreferences = action?.payload?.data?.data
      })
      .addCase(authActions.getUserPreferencesAction.rejected, (state, action: any) => {
        state.loading = false;
        state.accountPreferences = null;
      })
      // -------- Logout action handler -------
      .addCase(authActions.logoutAction.fulfilled, (state, action) => {
        state.isAuthenticated = false;
        state.token = null;
        state.userObject = {permissions: [], projectId: ""};
        state.error = "";
        state.loading = false;
        state.loginSuccess = false;
        
        state.isPrimaryUser = false;
        state.isReadOnly = false;
        localStorage.removeItem("isPrimaryUser");
        localStorage.removeItem("isReadOnly");

        state.accountPreferences = null;
        state.projectList = [];
      })
  },
  
});
// Export for Logout
export const { logout } = authSlice.actions;
// Export for ResetErrors
export const {resetError} = authSlice.actions;
// Export for loginFromBackOffice
export const { loginFromBackoffice } = authSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
// export const token = (state: RootState) => state.login.token;


export default authSlice.reducer;
